import { render, staticRenderFns } from "./city-sort.vue?vue&type=template&id=4c280cfc&"
import script from "./city-sort.vue?vue&type=script&lang=js&"
export * from "./city-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports